<template src="../templates/normal_fcont_186.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'
import FuncSearchGallery from '../components/FuncSearchGallery'
import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import { Carousel, Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    FuncSearchGallery, LabelFunMessage, Carousel, Slide, FuncSearchRecommendLink,
    FuncSearchGalleryQR, ReleaseDateForArticle, InfoMachineTranslation,
    AppDownloadiPrint, AppDownloadSmartPanel
  },
  data() {
    return {
      articleId: '186',
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['186-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['186-3'] }
      ]
    };
  }

};
</script>
<style scoped>
.up_space{
  margin-top: 30px;
}

</style>

